import QuoteIcon from '@assets/svg/icons/quote.svg'
import { ReviewCardIsCroppedContext } from '@contexts/review-card-is-cropped'
import Rating from '@ui/rating'
import clsx from 'clsx'
import React, {
  type ElementType,
  type FC,
  useCallback,
  useContext,
  useState,
} from 'react'

type ReviewCardProps = {
  title?: string
  content: string
  rate: number
  displayName: string
  publishedDate: string
  Icon: ElementType
}

export const ReviewCard: FC<ReviewCardProps> = ({
  title,
  content,
  rate,
  displayName,
  publishedDate,
  Icon,
  ...props
}) => {
  const isCropped = useContext(ReviewCardIsCroppedContext)
  const [isHover, setIsHover] = useState(false)

  const toggleHover = useCallback(() => {
    setIsHover((prevIsHover) => !prevIsHover)
  }, [])

  return (
    <div
      className={clsx(
        // todo remplacer par le composant card @fortuneo/ui
        'relative w-full rounded-[0.625rem] border border-solid border-theme-default-accent2 bg-background-default px-8 py-10 shadow-[0_5px_10px_0_rgb(35,35,35,0.06)] [overflow:inherit] hover:-mt-1 hover:mb-1',
        isCropped ? 'h-full justify-between' : 'h-auto justify-start'
      )}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
      {...props}
    >
      <div
        className={clsx(
          'absolute -top-4 transition-transform duration-200',
          isHover ? 'scale-125' : 'scale-1'
        )}
      >
        <QuoteIcon className="quote-icon" />
      </div>
      <Rating className="mb-2" value={rate} />
      {title && <p className="mb-2 text-085 font-medium">{title}</p>}
      <p
        className={clsx(
          'text-085',
          isCropped && 'line-clamp-3 text-ellipsis laptop:line-clamp-4'
        )}
      >
        {content}
      </p>
      <div className="mt-6 flex items-center">
        <Icon className="mr-3 w-[33px]" />
        <div className="flex flex-col leading-auto">
          <span className="text-085 font-medium">{displayName}</span>
          <span className="text-075 text-grey-300">{publishedDate}</span>
        </div>
      </div>
    </div>
  )
}
